// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './Title.themes';

export type TitleProps = {
  children: Node,
  className?: string,
  color?: 'current' | Colors,
  hasEllipsis?: boolean,
  hLevel?: number,
  iconColor?: Colors,
  iconName?: IconName,
  iconSize?: string,
  id?: string,
  role?: string,
  theme?: $Keys<typeof themes>,
};

export function Title(props: TitleProps) {
  const {
    children,
    className,
    color,
    hasEllipsis,
    hLevel = 2,
    iconColor,
    iconName,
    iconSize,
    id,
    role,
    theme = 'title-brand-5',
  } = props;

  const { thDefaultColor, thIcon, thIconSize, thTitle } = themes[theme] || {}; // prevent bad handwriting

  const TagName = `h${hLevel}`;
  const textColor = color || thDefaultColor;
  const classes = classnames(className, 'reset-heading', `text-${textColor}`, thTitle);

  return children ? (
    <TagName className={classes} id={id} {...(role ? { role } : null)}>
      <Icon
        className={classnames(thIcon, 'flex-shrink-0')}
        color={iconColor}
        name={iconName}
        width={iconSize || thIconSize || '1em'}
      />
      {hasEllipsis ? <span className="truncate w-full">{children}</span> : children}
    </TagName>
  ) : null;
}
